const calculateAmounts = (from, pay, to) => {
  try {
    if (!from || !pay ) {
      //   return { from, pay, to };
      throw new Error("Please check entered amount");
    }
    // console.log({ from, pay, to });

    if (from < 0 || from < pay) {
      throw new Error("Not availble enough amount");
    }

    return {
      from: from - pay,
      to: to + pay,
    };
  } catch (error) {
    throw Error(error);
  }
};

const updateNetworkBalence = (networks, amounts) => {
  const arr = [];
  for (let i = 0; i < networks.length; i++) {
    const element = networks[i];
    if (element.isSelectedAsFrom) {
      element.balance = amounts.from;
    }
    if (element.isSelectedAsTo) {
      element.balance = amounts.to;
    }
    arr.push(element);
  }
  return arr;
};

const swapNetworks = (networks) => {
  const arr = [];
  for (let i = 0; i < networks.length; i++) {
    const element = networks[i];
    if (element.isSelectedAsFrom) {
      element.isSelectedAsFrom = false;
      element.isSelectedAsTo = true;
      arr.push(element);
      continue
    }
    if (element.isSelectedAsTo) {
      element.isSelectedAsTo = false;
      element.isSelectedAsFrom = true;
    }
    arr.push(element);
  }
  return arr;
};

export { calculateAmounts, updateNetworkBalence, swapNetworks };
